import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import { load } from "@cashfreepayments/cashfree-js";

const CheckoutPage = () => {
    const [paymentSessionId, setPaymentSessionId] = useState(null);
    const userId = useSelector((state) => state.auth.user?.id);
    const { productId } = useParams(); // Capture productId from URL if available
    const [orderId, setOrderId] = useState(null);

    useEffect(() => {
        const createPayment = async () => {
            if (!userId) {
                console.error("User not authenticated");
                return;
            }

            try {
                const endpoint = productId
                    ? `${API_ENDPOINTS.PLACE_SINGLE_ORDER}/${productId}?userId=${userId}`
                    : `${API_ENDPOINTS.PLACE_ALL_ORDER}?userId=${userId}`;

                    console.log("endPoint :: ",endpoint)
                const response = await axiosInstance.post(endpoint);
                console.log("Response from placeOrder API:", response.data);

                const orderData = response.data;
                setOrderId(orderData.orderId);

                if (orderData.payment_session_id) {
                    setPaymentSessionId(orderData.payment_session_id);
                } else {
                    console.error("Failed to create order or payment session:", response.data.message);
                }
            } catch (error) {
                console.error("Error creating payment session:", error);
            }
        };

        createPayment();
    }, [userId, productId]);

    useEffect(() => {
        if (paymentSessionId) {
            load({
                mode: "production", // Change to "production" "sandbox" for live
            })
                .then((cashfree) => {
                    cashfree.checkout({
                        paymentSessionId,
                    });
                })
                .catch((error) => {
                    console.error("Error loading Cashfree SDK:", error);
                });
        }
    }, [paymentSessionId, orderId]);

    return (
        <div>
            <h2>Redirecting to payment...</h2>
            <div id="payment-form"></div>
        </div>
    );
};

export default CheckoutPage;
